import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Spinner from 'components/shared/Spinner';
import Link from 'components/shared/Link';
import Button from 'components/shared/Button';

type CartHeaderProps = {
  loading: boolean;
  handleContinueOrder: () => void;
};

function CartHeader(props: CartHeaderProps) {
  const { loading, handleContinueOrder } = props;

  return (
    <div className="cart_header">
      <div className="cart-header-links">
        <Button
          type="link"
          onClick={handleContinueOrder}
          id="continue_ordering_button"
          className="continue_ordering_button"
        >
          <FontAwesomeIcon icon="arrow-circle-left" /> Continue Ordering
        </Button>
        {!loading && (
          <Link href="/checkout" id="checkout_button" className="checkout_link">
            Checkout <FontAwesomeIcon icon="arrow-circle-right" />
          </Link>
        )}
      </div>
      <h2 className="title">Items in Your Cart</h2>
      {loading && <Spinner size="24" />}
    </div>
  );
}

export default CartHeader;
